import {
  HEARING_EXPORT_FORMAT_EXCEL,
  HEARING_EXPORT_FORMAT_USER_REPORT_EXCEL,
  HEARING_EXPORT_FORMAT_HEARING_RESPONSE_EXCEL,
} from './api';

export const excelExports = (
  translator,
  downloadReport,
  canDownloadReport,
  canDownloadUserReport,
  canDownloadHearingResponseReport,
  buttonStyles,
) => {
  return [
    {
      municipalities: ['all'],
      commandBarItem: {
        key: 'downloadexcelreport',
        name: translator('pages.createHearing.downloadExcelReport'),
        iconProps: {
          iconName: 'ExcelDocument',
        },
        disabled: !canDownloadReport,
        onClick: () => downloadReport(HEARING_EXPORT_FORMAT_EXCEL),
        buttonStyles,
      },
    },
    {
      municipalities: ['all'],
      commandBarItem: {
        key: 'downloadexceluserreport',
        name: translator('pages.createHearing.downloadExcelUserReport'),
        iconProps: {
          iconName: 'ExcelDocument',
        },
        disabled: !canDownloadUserReport,
        onClick: () => downloadReport(HEARING_EXPORT_FORMAT_USER_REPORT_EXCEL),
        buttonStyles,
      },
    },
    {
      municipalities: ['all'],
      commandBarItem: {
        key: 'downloadexcelhearingresponsereport',
        name: translator(
          'pages.createHearing.downloadExcelHearingResponseReport',
        ),
        iconProps: {
          iconName: 'ExcelDocument',
        },
        disabled: !canDownloadHearingResponseReport,
        onClick: () =>
          downloadReport(HEARING_EXPORT_FORMAT_HEARING_RESPONSE_EXCEL),
        buttonStyles,
      },
    },
  ];
};
